var MANUAL_OPERATION_ERROR = 'THIS IS A MANUAL OPERATION - SET PENALTY MANUALLY';
export var isManualOperationError = function (message) {
    return message === null || message === void 0 ? void 0 : message.includes(MANUAL_OPERATION_ERROR);
};
